import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcRequirementTypeById,
    setCcRequirementTypeEdit,
    setCcRequirementTypeReloadEdit,
    initCcRequirementType,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface TypeEditProps {
    typeId: number
    editAccess: boolean
}

const Edit = ({
    typeId,
    editAccess,
}: TypeEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const type = useSelector((state: StoreType) => state.ccRequirementType.typeEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccRequirementType.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcRequirementTypeReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcRequirementTypeReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (typeId === 0) {
            dispatch(setCcRequirementTypeEdit(initCcRequirementType))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcRequirementTypeById(typeId, userData.accountId, project.id).then((res) => {
                dispatch(setCcRequirementTypeEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!type) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {
                        type.id
                            ? (editAccess ? `${lang.editType} #${type.id}` : `${lang.viewType} #${type.id}`)
                            : lang.addType
                    }
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form type={type} editAccess={editAccess} />
                }
                {
                    reloadEdit
                    && <Form type={type} editAccess={editAccess} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
